import { interval, of, EMPTY } from 'rxjs'
import { mergeMap, map, takeUntil, pluck, filter, startWith } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { messagingActions } from '../../../slices/messaging'
import selectWebcastDate from '../../../selectors/selectWebcastData'
import get from 'lodash/get'
import getAnnouncementsDisabled from '../../../../lib/getAnnouncementsDisabled'

const announcementsStatePolling$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(setupTypes.SET_ROOM),
  filter(() =>
    (
      usernameLib.isPresenter(state$.value.config.username || '') ||
      usernameLib.isObserver(state$.value.config.username || '')
    ) &&
    state$.value.config.featureFlags.announcements &&
    state$.value.messaging.isDisabled
  ),
  mergeMap(() => {

    return interval(10000).pipe(
      takeUntil(
        action$.pipe(
          ofType(messagingActions.setAnnouncementsState.type),
          pluck('payload'),
          map(value => value === false)
        )
      ),
      startWith(() => of(
        messagingActions.setAnnouncementsState(
          getAnnouncementsDisabled(
            get(selectWebcastDate(state$.value), 'entryTime', '')
          )
        )
      )),
      mergeMap(() => {

        const webcast = selectWebcastDate(state$.value)
        const isDisabled = getAnnouncementsDisabled(get(webcast, 'entryTime', ''))

        return isDisabled
          ? EMPTY
          : of(messagingActions.setAnnouncementsState(false))

      })
    )

  })
)

export default announcementsStatePolling$
